import React, { Component } from 'react';
import { api } from "../rest";
import swal from "sweetalert2";
import Loading from "./loading";

export default class FormModel extends Component {
	constructor () {
		super();
		this.state = {
			modelo: "",
			external: false,
			fetching: false
		};
		this.handleFormSubmit = this.handleFormSubmit.bind(this);
		this.handleModelChange = this.handleModelChange.bind(this);
		this.handleExternalChange = this.handleExternalChange.bind(this);
	}

	handleFormSubmit (e) {
		e.preventDefault();
		this.setState({fetching: true});
		api.post("/models",{name: this.state.modelo,external: this.state.external})
		.then((response)=>{
			swal("Modelo creado",this.state.modelo,"success");
			this.setState({fetching: false});
			this.setState({modelo: ""});
		})
		.catch((error)=>{
			this.setState({fetching: false});
			if (error.response.status === 406) {
				swal("Error", `Ya existe un modelo con ese nombre`,"error");
			} else {
				swal("Error", `Status: ${error.response.status}`,"error");
			}
		});
	}
	handleModelChange ({target: {value}}) {
		this.setState({modelo: value});
	}
	handleExternalChange ({target: {value}}) {
		this.setState({external: !this.state.external});
	}
	render() {
		return (
			<form className="group columns small-12" onSubmit={this.handleFormSubmit}>
				<Loading loading={this.state.fetching}/>
				<div className="group-title">Crear nuevo modelo</div>
				<div className="row">
					<label className="columns small-6">
						<em>Modelo</em>
						<input type="text" value={this.state.modelo} onChange={this.handleModelChange} required autoFocus/>
					</label>
					<label className="columns small-1">
						<em>Externo</em>
						<br/>
						<input type="checkbox" checked={this.state.external} value={this.state.external} onChange={this.handleExternalChange}/>
					</label>
					<label className="columns small-5">
						<em> </em>
						<button type="submit" className="button success expanded" disabled={this.state.fetching}>Guardar</button>
					</label>
				</div>
			</form>
		);
	}
}


/** WEBPACK FOOTER **
 ** ./src/components/form_model.js
 **/